export default "__VITE_ASSET__BYr0R0cG__"